<form
  class="phone-number-input"
  [formGroup]="form"
>
  <mat-form-field class="form-field required-field">
    <input
      type="tel"
      class="form-field__phone"
      matInput
      appFormControl
      [placeholder]="'Phone Number' + (required ? ' *' : '')"
      formControlName="billing_phone_number"
    >
  </mat-form-field>

  <mat-form-field class="form-field extention">
    <input
      type="text"
      class="form-field__phone"
      matInput
      appFormControl
      placeholder="Phone Ext"
      formControlName="billing_phone_ext"
      maxlength="6"
      (keypress)="InputHelper.numberInput($event)"
    >
  </mat-form-field>
</form>
